import { useEffect } from 'react'

import { Snackbar } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';

import { useToastState, IToast, useToastActions } from 'contexts/toast';

const Toast = () => {

  const { toasts } = useToastState()

  return (
    <div>
      {toasts.map((item: IToast, i: number) => (
        <ToastItem
          id={item.id}
          name={item.name}
          description={item.description}
          key={i}
        />
      ))}
    </div>
  )
}

const ToastItem = ({ id, name, description }: IToast) => {

  const { closeToast } = useToastActions()

  useEffect(() => {
    window.setTimeout(() => {
      closeToast(id);
    }, 5000);
  }, []);

  return (
    <Snackbar
      open
      onClose={() => closeToast(id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        elevation={6}
        variant="filled"
        severity={name}
        onClose={() => { closeToast(id) }}
      >
        <AlertTitle style={{ margin: '0 20px 0 0' }}>
          {name.toUpperCase()}
        </AlertTitle>
        {description}
      </Alert>
    </Snackbar >
  )
}

export default Toast